import { render, staticRenderFns } from "./ici-image-preview.vue?vue&type=template&id=20a1778e&"
import script from "./ici-image-preview.vue?vue&type=script&lang=js&"
export * from "./ici-image-preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports